import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

type Props = {config: ConfigObjectType};
const RFReportsLayoutContainer: React.FC<Props> = (props) => {
  return <>TODO</>;
};
